import { createRouter, createWebHistory } from "vue-router";

import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Services from "../views/Services.vue";
import Projects from "../views/Projects.vue";
import Contact from "../views/Contact.vue";
import NotFound from "../views/404.vue";
import { applyHead } from "../utils/head";

// Titles stay under ~60 chars and descriptions under ~155 so they don't get
// truncated in search results.
const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: "EIKA Interiors | Interior Design & Renovation in Singapore",
      description:
        "Singapore interior design studio crafting warm, natural homes for HDB, condo and landed properties. Design, renovation and styling in one place. Rated 4.9 on Google.",
    },
  },
  {
    path: "/about",
    name: "about",
    component: About,
    meta: {
      title: "About Our Studio | EIKA Interiors Singapore",
      description:
        "A Singapore interior design studio rooted in wabi-sabi, built on honest materials, considered space, and carpentry made in our own Sin Ming workshop.",
    },
  },
  {
    path: "/services",
    name: "services",
    component: Services,
    meta: {
      title: "Interior Design, Renovation & Styling | EIKA Interiors",
      description:
        "Interior design, renovation and styling for Singapore homes. Space planning, in-house carpentry and joinery, and furniture curation, from concept to handover.",
    },
  },
  {
    path: "/projects",
    name: "projects",
    component: Projects,
    meta: {
      title: "Our Projects | Interior Design Portfolio Singapore",
      description:
        "Selected interiors crafted by EIKA, featuring kitchens, living spaces and dining nooks across Singapore homes, in warm natural materials.",
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
    meta: {
      title: "Contact Us | EIKA Interiors Singapore",
      description:
        "Talk to EIKA Interiors about your home. Office at Stellar @ Tampines, workshop at Sin Ming. WhatsApp, email or send us an enquiry.",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFound,
    meta: { title: "Page Not Found | EIKA Interiors", description: "" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

router.afterEach((to) => applyHead(to));

export default router;
